@if (isLoading()) {
  <mat-progress-bar
    class="crl-progress"
    mode="indeterminate"
    [dataSelector]="'cxp-crl-loading-bar'"
  ></mat-progress-bar>
}

@if (display(); as display) {
  <div class="crl-grid">
    <div class="crl-main">
      <cxp-crl-page-header
        [name]="display.name ?? ''"
        [eyebrow]="display.eyebrow"
        [description]="display.description"
        [showBreadcrumb]="showBreadcrumb()"
      />

      <cxp-crl-progress-tiles
        [progress]="display.progress"
        [tiles]="display.tiles"
        [selection]="selection()"
        (tileToggled)="onTileToggled($event)"
      />

      @if (display.actionRequired.show) {
        <cxp-crl-action-banner
          [summary]="display.actionRequired"
          [filterActive]="isActionFilterActive()"
          (filterRequested)="onFilterRequested()"
        />
      }

      @if (canBulkUpload()) {
        <cxp-crl-bulk-dropzone (filesSelected)="onFilesSelected($event)" />
      }

      @if (canViewUncategorizedFiles() && uncategorizedCardVm().visible) {
        <cxp-crl-uncategorized-files-card
          [vm]="uncategorizedCardVm()"
          (removeFile)="onRemoveUncategorized($event)"
        />
      }

      <cxp-crl-search-filter-bar
        [filterOptions]="filterOptions()"
        [searchQuery]="searchQuery()"
        [sectionOptions]="sectionOptions()"
        [selectedSectionId]="sectionFilter()"
        [bulkActionsActive]="bulkMode()"
        (filterToggled)="onFilterToggled($event)"
        (searchChanged)="onSearchChanged($event)"
        (clearAllFilters)="onClearAllFilters()"
        (sectionChanged)="onSectionChanged($event)"
        (bulkActionsToggled)="onBulkModeToggled()"
      />

      @if (bulkMode()) {
        <cxp-crl-bulk-action-bar
          [selectedCount]="selectedCount()"
          (action)="onBulkAction($event)"
          (done)="onBulkDone()"
        />
      }

      @if (hasSections()) {
        <cxp-crl-section-list
          [sections]="filteredSections()"
          [selectionMode]="bulkMode()"
          [selectedItemIds]="selectedItemIds()"
          [undoPendingItemIds]="undoPendingItemIds()"
          (itemSelected)="onItemSelected($event)"
          (commentsSelected)="onItemCommentsSelected($event)"
          (itemSelectionToggled)="onItemSelectionToggled($event)"
          (itemNotApplicableUndone)="onItemNotApplicableUndone($event)"
        />
      } @else if (isFilteredEmpty()) {
        <p class="crl-sections-empty">No requests match your filters.</p>
      } @else {
        <p class="crl-sections-empty">No requests to show yet.</p>
      }
    </div>

    <aside class="crl-rail">
      <cxp-crl-right-rail [team]="display.team" [clientContacts]="display.clientContacts" />
    </aside>

    <!--
      Per-item detail overlay: the named `panel` outlet when routed, the panel
      itself when hosted. Either way it draws as a fixed, scrim-backed drawer
      above the page, so this slot reserves no layout space and the list + rail
      keep their grid.
    -->
    @if (isHosted()) {
      @if (hostedSelectedItemId() !== null) {
        <cxp-crl-panel />
      }
    } @else {
      <router-outlet name="panel" />
    }
  </div>
}

<!-- Upload-progress toast: fixed bottom-right, independent of the request-detail
     load state. Self-hides when nothing is tracked. -->
<cxp-upload-toast />
